import Cookies from 'js-cookie'

export default function validTokenExists() {
  const TOKEN_JSON = Cookies.get('token')
  if (TOKEN_JSON) {
    const TOKEN = JSON.parse(TOKEN_JSON)
    const tokenExpDate = new Date(TOKEN?.expiration_date).getTime()
    const currentDate = new Date().getTime()
    if (!tokenExpDate || currentDate > tokenExpDate) {
      Cookies.remove('token')
      return false
    } else {
      // verify token by calling /userinfo (Requirement set by Louis in Orthofix IT)
      // perhaps we can simply make this call once during the GET_TOKEN flow
      // only make this call if we haven't checked in awhile
      // if the call fails then the token is expired
      return true
      // if call fails return false
    }
  } else {
    return false
  }
}
